export default {

    methods: {
        async deleteAlert(title, text, showCancelButton = true, confirmButtonColor = "#3085d6", cancelButtonColor = "#d33", confirmButtonText = "Yes, delete it!", cancelButtonText = "Cancel") {
            return this.$swal.fire({
                title,
                text,
                type: "warning",
                showCancelButton,
                confirmButtonColor,
                confirmButtonText,
                cancelButtonColor,
                cancelButtonText,
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                return !!result.value;
            });
        },
    }
}
